const isWithin = (pathname: string, path: string) => pathname === path || pathname.startsWith(`${path}/`);

export function isNavSelected(navPath: string, pathname: string, siblingPaths: string[]): boolean {
  if (navPath === '/') {
    return pathname === '/';
  }

  return (
    isWithin(pathname, navPath) &&
    !siblingPaths.some((sibling) => sibling.startsWith(`${navPath}/`) && isWithin(pathname, sibling))
  );
}
